import React, { useState, useContext } from "react";
import { BreakpointContext } from "components/common";
import IQHeader from "./Header";
import { LandingDefault } from "./LandingHelper";

const baseDomain = "https://www.freeform.chat";

const ROUTES_WEBSITE = "tomo-lead-gen";
const ROUTES_APP = "tomo-app";

const routes = [ROUTES_WEBSITE, ROUTES_APP];

const IQLanding = ({
  match: {
    params: { platform },
  },
}) => {
  const { isBelow } = useContext(BreakpointContext);
  const belowMd = isBelow("md");
  const [renderChat, setRenderChat] = useState(false);
  const currentRoute = routes.find((r) => r === platform) || ROUTES_WEBSITE;
  const link = `${baseDomain}/${currentRoute}`;

  return (
    <div className="flex flex-col h-screen">
      <IQHeader />
      <div
        className={`w-full h-full bg-black ${renderChat ? "block" : "hidden"}`}
      >
        <iframe
          src={link}
          className="flex-1 border-0 w-full h-full"
          title="chatbot"
        />
      </div>
      {!renderChat && (
        <LandingDefault belowMd={belowMd} setRenderChat={setRenderChat} />
      )}
    </div>
  );
};

export default IQLanding;
